import React, {Component} from 'react'
import LoginModal from './LoginModal'
import SettingsModal from './SettingsModal'
import {withRouter} from 'react-router-dom'
import moment from 'moment'
import WarningIcon from '@material-ui/icons/Warning'
import { red } from '@material-ui/core/colors';

class UserOrLogin extends Component {
  state = {
    open: false,
    settingsOpen: false,
    currentUser: undefined,
  }

  onOpenSettingsModal = () => {
    this.setState({settingsOpen: true})
  }

  onCloseSettingsModal = () => {
    this.setState({settingsOpen: false})
  }

  onOpenModal = () => {
    this.setState({open: true})
  }

  onCloseModal = () => {
    this.setState({open: false})
  }

  logout = () => {
    window.firebaseApp.auth().signOut()
    this.onCloseModal()
    this.onCloseSettingsModal()
    this.setState({currentUser: undefined}, this.props.history.push('/'))
  }



  componentDidMount() {
    let _this = this
    window.firebaseApp.auth().onAuthStateChanged(async function (user) {
      console.info("ASYNC USER:")
      console.info(user)
      if (user) {
        let userId = window.firebaseApp.auth().getUid()
        let membership =
          userId &&
          (await (await window.firebaseDb.collection('memberships'))
            .where('userId', '==', userId)
            .get())
        let now = moment()
        let monthInMilli = 60*60*24*30*1000
        membership = membership && !membership.empty && membership.docs[0].data()

        let expiring = false
        if (membership) {
          let timeLeft = membership.end.seconds*1000 - now.toDate().getTime()
          if(timeLeft < monthInMilli){
            expiring = true
          }
        }
        console.info("SETTING STATE")
        _this.setState({
          currentUser: user,
          membership: membership,
          expiring: expiring
        })
      }
    })
  }

  render() {
    const {open, settingsOpen} = this.state
    let {expiring, membership} = this.state
    let user = this.state.currentUser
  
    return (
      <div>
        
        {user && (
          <button className="signup-button" onClick={this.onOpenSettingsModal}>
            {expiring && <WarningIcon className="blink_me" style={{ color: red[500] }} />}
            {user.displayName}
          </button>
        )}
        {!user && (
          <button className="signup-button" onClick={this.onOpenModal}>
            Signup / Login
          </button>
        )}
        <LoginModal open={open} onClose={this.onCloseModal} />
        <SettingsModal
          currentUser={this.state.currentUser}
          membership={this.state.membership}
          expiring={this.state.expiring}
          open={settingsOpen}
          onClose={this.onCloseSettingsModal}
          logout={this.logout}
        />
      </div>
    )
  }
}

export default withRouter(UserOrLogin)



// WEBPACK FOOTER //
// ./src/components/UserOrLogin.jsx